import { Action, createReducer, on } from '@ngrx/store';
import * as DelegationsActions from 'src/app/delegations/store/actions/delegations.actions';
import { DelegationsState } from 'src/app/delegations/store/delegations.state';

export const initialState: DelegationsState = {
    loadingAssignedToMeDelegations: false,
    assignedToMeDelegations: [],
    loadingEmployees: false,
    delegationEmployees: [],
    loadingOwnerDelegations: false,
    ownerDelegations: [],
    error: undefined
};

const reducer = createReducer(
    initialState,

    on(
        DelegationsActions.createDelegation,
        DelegationsActions.updateDelegation,
        DelegationsActions.setDelegationToInactive,
        (state) => ({
            ...state,
            loadingOwnerDelegations: true
        })
    ),

    on(
        DelegationsActions.createDelegationSuccess,
        DelegationsActions.updateDelegationSuccess,
        DelegationsActions.setDelegationToInactiveSuccess,
        (state) => ({
            ...state,
            loadingOwnerDelegations: false
        })
    ),

    on(
        DelegationsActions.createDelegationFailure,
        DelegationsActions.updateDelegationFailure,
        DelegationsActions.setDelegationToInactiveFailure,
        (state, action) => ({
            ...state,
            loadingOwnerDelegations: false,
            error: action.error
        })
    ),

    on(DelegationsActions.getAssignedToMeDelegations, (state) => ({
        ...state,
        loadingAssignedToMeDelegations: true
    })),

    on(DelegationsActions.getAssignedToMeDelegationsSuccess, (state, action) => ({
        ...state,
        assignedToMeDelegations: action.delegations,
        loadingAssignedToMeDelegations: false
    })),

    on(DelegationsActions.getAssignedToMeDelegationsFailure, (state, action) => ({
        ...state,
        assignedToMeDelegations: [],
        loadingAssignedToMeDelegations: false,
        error: action.error
    })),

    on(DelegationsActions.clearAssignedToMeDelegations, (state) => ({
        ...state,
        assignedToMeDelegations: []
    })),

    on(DelegationsActions.searchDelegationEmployees, (state) => ({
        ...state,
        loadingEmployees: true
    })),

    on(DelegationsActions.searchDelegationEmployeesSuccess, (state, action) => ({
        ...state,
        loadingEmployees: false,
        delegationEmployees: action.delegationEmployees
    })),

    on(DelegationsActions.searchDelegationEmployeesFailure, (state, action) => ({
        ...state,
        loadingEmployees: false,
        error: action.error,
        delegationEmployees: []
    })),

    on(DelegationsActions.clearDelegationEmployees, (state) => ({
        ...state,
        delegationEmployees: []
    })),

    on(DelegationsActions.getOwnerDelegations, (state) => ({
        ...state,
        loadingOwnerDelegations: true
    })),

    on(DelegationsActions.getOwnerDelegationsSuccess, (state, action) => ({
        ...state,
        ownerDelegations: action.delegations,
        loadingOwnerDelegations: false
    })),

    on(DelegationsActions.getOwnerDelegationsFailure, (state, action) => ({
        ...state,
        ownerDelegations: [],
        loadingOwnerDelegations: false,
        error: action.error
    })),

    on(DelegationsActions.clearOwnerDelegations, (state) => ({
        ...state,
        ownerDelegations: []
    })),

    on(DelegationsActions.setDelegationToInactive, (state) => ({
        ...state,
        loadingOwnerDelegations: true
    }))
);

export function delegationsReducer(state: DelegationsState | undefined, action: Action) {
    return reducer(state, action);
}
